import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../graphql-types'

const defaultOptions = {} as const
export type GotsChatSubscriptionSubscriptionVariables = Types.Exact<{
  input: Types.OracleAgentChatInput;
}>;

export type GotsChatSubscriptionSubscription = { __typename?: 'Subscription', oracleAgentChat: { __typename?: 'OracleAgentChatSubscriptionPayload', chatSessionId?: string | null, messagePairId?: string | null, textChunk?: string | null, error?: string | null, success: boolean, sessionTitle?: string | null, isFinal: boolean, errorInfo: Array<{ __typename?: 'AppError', code: string, message: string }>, documents?: Array<{ __typename?: 'OracleDocument', componentId: string, componentType: string, contentLink?: { __typename?: 'ContentLinkDocument', contentType: string, contentId: number, title: string, path: string } | null }> | null } };

export type GotsGetChatMessagesQueryVariables = Types.Exact<{
  chatSessionId: Types.Scalars['ID'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  order?: Types.InputMaybe<Array<Array<Types.Scalars['String']> | Types.Scalars['String']> | Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;

export type GotsGetChatMessagesQuery = { __typename?: 'Query', oracleMessagePairList: { __typename?: 'OracleMessagePairListResponse', oracleMessagePairs: Array<{ __typename?: 'OracleMessagePair', id: string, createdAt: string, thumbsValue: string, userMessage: { __typename?: 'OracleMessage', content: string }, oracleMessage: { __typename?: 'OracleMessage', content: string }, documents: Array<{ __typename?: 'OracleDocument', componentId: string, componentType: string, contentLink?: { __typename?: 'ContentLinkDocument', contentType: string, contentId: number, title: string, path: string } | null }> }> } };

export type GotsUpdateMessagePairThumbsMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  input: Types.OracleMessagePairUpdateInput;
}>;

export type GotsUpdateMessagePairThumbsMutation = { __typename?: 'Mutation', oracleMessagePairUpdate: { __typename?: 'OracleMessagePairUpdateResponse', success: boolean, errors: Array<string>, oracleMessagePair?: { __typename?: 'OracleMessagePair', id: string, thumbsValue: string } | null } };

export type VideoAutoSummaryQueryVariables = Types.Exact<{
  input: Types.VideoAutoSummaryInput;
}>;

export type VideoAutoSummaryQuery = { __typename?: 'Query', videoAutoSummary?: { __typename?: 'VideoAutoSummaryPayload', summary: string, captionCount: number, lastCaptionTime?: string | null, generatedAt: string } | null };

export type VideoPromptSuggestionsQueryVariables = Types.Exact<{
  input: Types.VideoPromptSuggestionsInput;
}>;

export type VideoPromptSuggestionsQuery = { __typename?: 'Query', videoPromptSuggestions?: { __typename?: 'VideoPromptSuggestionsPayload', totalChunksConsidered: number, contextChunksUsed: number, coverageStartTimecode?: string | null, coverageEndTimecode?: string | null, generatedAt: string, suggestions: Array<{ __typename?: 'VideoPromptSuggestion', prompt: string, focus: string, rationale: string }> } | null };

export type VideoConceptMomentsQueryVariables = Types.Exact<{
  input: Types.VideoConceptMomentsInput;
}>;

export type VideoConceptMomentsQuery = { __typename?: 'Query', videoConceptMoments?: { __typename?: 'VideoConceptMomentsPayload', videoDurationEstimate?: number | null, generatedAt: string, fromCache: boolean, status?: string | null, moments: Array<{ __typename?: 'VideoConceptMoment', startTimecode: string, endTimecode: string, startSeconds: number, endSeconds: number, conceptLabel: string, densityScore: number }> } | null };

export type VideoConceptMomentSummaryQueryVariables = Types.Exact<{
  input: Types.VideoConceptMomentSummaryInput;
}>;

export type VideoConceptMomentSummaryQuery = { __typename?: 'Query', videoConceptMomentSummary?: { __typename?: 'VideoConceptMomentSummaryPayload', summary: string, conceptLabel: string, captionCount: number, startTimecode: string, endTimecode: string, generatedAt: string } | null };

export type VideoConceptMomentPromptsQueryVariables = Types.Exact<{
  input: Types.VideoConceptMomentPromptsInput;
}>;

export type VideoConceptMomentPromptsQuery = { __typename?: 'Query', videoConceptMomentPrompts?: { __typename?: 'VideoConceptMomentPromptsPayload', conceptLabel: string, generatedAt: string, prompts: Array<{ __typename?: 'VideoPromptSuggestion', prompt: string, focus: string, rationale: string }> } | null };

export type GetChatSessionByVideoQueryVariables = Types.Exact<{
  contentId: Types.Scalars['String'];
  featureMediaId: Types.Scalars['String'];
}>;

export type GetChatSessionByVideoQuery = { __typename?: 'Query', oracleChatSessionList: { __typename?: 'OracleChatSessionListResponse', limit: number, offset: number, count: number, oracleChatSessions: Array<{ __typename?: 'OracleChatSession', id: string, name: string, personalityId: string, contentId?: string | null, featureMediaId?: string | null, updatedAt: string, createdAt: string }> } };

export const GotsChatSubscriptionDocument = gql`
    subscription GotsChatSubscription($input: OracleAgentChatInput!) {
  oracleAgentChat(input: $input) {
    chatSessionId
    messagePairId
    textChunk
    error
    success
    errorInfo {
      code
      message
    }
    sessionTitle
    isFinal
    documents {
      componentId
      componentType
      contentLink {
        contentType
        contentId
        title
        path
      }
    }
  }
}
    `

/**
 * __useGotsChatSubscriptionSubscription__
 *
 * To run a query within a React component, call `useGotsChatSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGotsChatSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGotsChatSubscriptionSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGotsChatSubscriptionSubscription (baseOptions: Apollo.SubscriptionHookOptions<GotsChatSubscriptionSubscription, GotsChatSubscriptionSubscriptionVariables> & ({ variables: GotsChatSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<GotsChatSubscriptionSubscription, GotsChatSubscriptionSubscriptionVariables>(GotsChatSubscriptionDocument, options)
}
export type GotsChatSubscriptionSubscriptionHookResult = ReturnType<typeof useGotsChatSubscriptionSubscription>;
export type GotsChatSubscriptionSubscriptionResult = Apollo.SubscriptionResult<GotsChatSubscriptionSubscription>;
export const GotsGetChatMessagesDocument = gql`
    query GotsGetChatMessages($chatSessionId: ID!, $limit: Int = 10, $offset: Int = 0, $order: [[String!]!] = [["createdAt", "ASC"]]) {
  oracleMessagePairList(
    chatSessionId: $chatSessionId
    useMaster: true
    limit: $limit
    offset: $offset
    order: $order
  ) {
    oracleMessagePairs {
      id
      createdAt
      thumbsValue
      userMessage {
        content
      }
      oracleMessage {
        content
      }
      documents {
        componentId
        componentType
        contentLink {
          contentType
          contentId
          title
          path
        }
      }
    }
  }
}
    `

/**
 * __useGotsGetChatMessagesQuery__
 *
 * To run a query within a React component, call `useGotsGetChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGotsGetChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGotsGetChatMessagesQuery({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGotsGetChatMessagesQuery (baseOptions: Apollo.QueryHookOptions<GotsGetChatMessagesQuery, GotsGetChatMessagesQueryVariables> & ({ variables: GotsGetChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GotsGetChatMessagesQuery, GotsGetChatMessagesQueryVariables>(GotsGetChatMessagesDocument, options)
}
export function useGotsGetChatMessagesLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<GotsGetChatMessagesQuery, GotsGetChatMessagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GotsGetChatMessagesQuery, GotsGetChatMessagesQueryVariables>(GotsGetChatMessagesDocument, options)
}
export function useGotsGetChatMessagesSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GotsGetChatMessagesQuery, GotsGetChatMessagesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GotsGetChatMessagesQuery, GotsGetChatMessagesQueryVariables>(GotsGetChatMessagesDocument, options)
}
export type GotsGetChatMessagesQueryHookResult = ReturnType<typeof useGotsGetChatMessagesQuery>;
export type GotsGetChatMessagesLazyQueryHookResult = ReturnType<typeof useGotsGetChatMessagesLazyQuery>;
export type GotsGetChatMessagesSuspenseQueryHookResult = ReturnType<typeof useGotsGetChatMessagesSuspenseQuery>;
export type GotsGetChatMessagesQueryResult = Apollo.QueryResult<GotsGetChatMessagesQuery, GotsGetChatMessagesQueryVariables>;
export const GotsUpdateMessagePairThumbsDocument = gql`
    mutation GotsUpdateMessagePairThumbs($id: ID!, $input: OracleMessagePairUpdateInput!) {
  oracleMessagePairUpdate(id: $id, input: $input) {
    success
    errors
    oracleMessagePair {
      id
      thumbsValue
    }
  }
}
    `
export type GotsUpdateMessagePairThumbsMutationFn = Apollo.MutationFunction<GotsUpdateMessagePairThumbsMutation, GotsUpdateMessagePairThumbsMutationVariables>;

/**
 * __useGotsUpdateMessagePairThumbsMutation__
 *
 * To run a mutation, you first call `useGotsUpdateMessagePairThumbsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGotsUpdateMessagePairThumbsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gotsUpdateMessagePairThumbsMutation, { data, loading, error }] = useGotsUpdateMessagePairThumbsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGotsUpdateMessagePairThumbsMutation (baseOptions?: Apollo.MutationHookOptions<GotsUpdateMessagePairThumbsMutation, GotsUpdateMessagePairThumbsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<GotsUpdateMessagePairThumbsMutation, GotsUpdateMessagePairThumbsMutationVariables>(GotsUpdateMessagePairThumbsDocument, options)
}
export type GotsUpdateMessagePairThumbsMutationHookResult = ReturnType<typeof useGotsUpdateMessagePairThumbsMutation>;
export type GotsUpdateMessagePairThumbsMutationResult = Apollo.MutationResult<GotsUpdateMessagePairThumbsMutation>;
export type GotsUpdateMessagePairThumbsMutationOptions = Apollo.BaseMutationOptions<GotsUpdateMessagePairThumbsMutation, GotsUpdateMessagePairThumbsMutationVariables>;
export const VideoAutoSummaryDocument = gql`
    query VideoAutoSummary($input: VideoAutoSummaryInput!) {
  videoAutoSummary(input: $input) {
    summary
    captionCount
    lastCaptionTime
    generatedAt
  }
}
    `

/**
 * __useVideoAutoSummaryQuery__
 *
 * To run a query within a React component, call `useVideoAutoSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoAutoSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoAutoSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVideoAutoSummaryQuery (baseOptions: Apollo.QueryHookOptions<VideoAutoSummaryQuery, VideoAutoSummaryQueryVariables> & ({ variables: VideoAutoSummaryQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VideoAutoSummaryQuery, VideoAutoSummaryQueryVariables>(VideoAutoSummaryDocument, options)
}
export function useVideoAutoSummaryLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<VideoAutoSummaryQuery, VideoAutoSummaryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VideoAutoSummaryQuery, VideoAutoSummaryQueryVariables>(VideoAutoSummaryDocument, options)
}
export function useVideoAutoSummarySuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoAutoSummaryQuery, VideoAutoSummaryQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<VideoAutoSummaryQuery, VideoAutoSummaryQueryVariables>(VideoAutoSummaryDocument, options)
}
export type VideoAutoSummaryQueryHookResult = ReturnType<typeof useVideoAutoSummaryQuery>;
export type VideoAutoSummaryLazyQueryHookResult = ReturnType<typeof useVideoAutoSummaryLazyQuery>;
export type VideoAutoSummarySuspenseQueryHookResult = ReturnType<typeof useVideoAutoSummarySuspenseQuery>;
export type VideoAutoSummaryQueryResult = Apollo.QueryResult<VideoAutoSummaryQuery, VideoAutoSummaryQueryVariables>;
export const VideoPromptSuggestionsDocument = gql`
    query VideoPromptSuggestions($input: VideoPromptSuggestionsInput!) {
  videoPromptSuggestions(input: $input) {
    suggestions {
      prompt
      focus
      rationale
    }
    totalChunksConsidered
    contextChunksUsed
    coverageStartTimecode
    coverageEndTimecode
    generatedAt
  }
}
    `

/**
 * __useVideoPromptSuggestionsQuery__
 *
 * To run a query within a React component, call `useVideoPromptSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoPromptSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoPromptSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVideoPromptSuggestionsQuery (baseOptions: Apollo.QueryHookOptions<VideoPromptSuggestionsQuery, VideoPromptSuggestionsQueryVariables> & ({ variables: VideoPromptSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VideoPromptSuggestionsQuery, VideoPromptSuggestionsQueryVariables>(VideoPromptSuggestionsDocument, options)
}
export function useVideoPromptSuggestionsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<VideoPromptSuggestionsQuery, VideoPromptSuggestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VideoPromptSuggestionsQuery, VideoPromptSuggestionsQueryVariables>(VideoPromptSuggestionsDocument, options)
}
export function useVideoPromptSuggestionsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoPromptSuggestionsQuery, VideoPromptSuggestionsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<VideoPromptSuggestionsQuery, VideoPromptSuggestionsQueryVariables>(VideoPromptSuggestionsDocument, options)
}
export type VideoPromptSuggestionsQueryHookResult = ReturnType<typeof useVideoPromptSuggestionsQuery>;
export type VideoPromptSuggestionsLazyQueryHookResult = ReturnType<typeof useVideoPromptSuggestionsLazyQuery>;
export type VideoPromptSuggestionsSuspenseQueryHookResult = ReturnType<typeof useVideoPromptSuggestionsSuspenseQuery>;
export type VideoPromptSuggestionsQueryResult = Apollo.QueryResult<VideoPromptSuggestionsQuery, VideoPromptSuggestionsQueryVariables>;
export const VideoConceptMomentsDocument = gql`
    query VideoConceptMoments($input: VideoConceptMomentsInput!) {
  videoConceptMoments(input: $input) {
    moments {
      startTimecode
      endTimecode
      startSeconds
      endSeconds
      conceptLabel
      densityScore
    }
    videoDurationEstimate
    generatedAt
    fromCache
    status
  }
}
    `

/**
 * __useVideoConceptMomentsQuery__
 *
 * To run a query within a React component, call `useVideoConceptMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoConceptMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoConceptMomentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVideoConceptMomentsQuery (baseOptions: Apollo.QueryHookOptions<VideoConceptMomentsQuery, VideoConceptMomentsQueryVariables> & ({ variables: VideoConceptMomentsQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VideoConceptMomentsQuery, VideoConceptMomentsQueryVariables>(VideoConceptMomentsDocument, options)
}
export function useVideoConceptMomentsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<VideoConceptMomentsQuery, VideoConceptMomentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VideoConceptMomentsQuery, VideoConceptMomentsQueryVariables>(VideoConceptMomentsDocument, options)
}
export function useVideoConceptMomentsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoConceptMomentsQuery, VideoConceptMomentsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<VideoConceptMomentsQuery, VideoConceptMomentsQueryVariables>(VideoConceptMomentsDocument, options)
}
export type VideoConceptMomentsQueryHookResult = ReturnType<typeof useVideoConceptMomentsQuery>;
export type VideoConceptMomentsLazyQueryHookResult = ReturnType<typeof useVideoConceptMomentsLazyQuery>;
export type VideoConceptMomentsSuspenseQueryHookResult = ReturnType<typeof useVideoConceptMomentsSuspenseQuery>;
export type VideoConceptMomentsQueryResult = Apollo.QueryResult<VideoConceptMomentsQuery, VideoConceptMomentsQueryVariables>;
export const VideoConceptMomentSummaryDocument = gql`
    query VideoConceptMomentSummary($input: VideoConceptMomentSummaryInput!) {
  videoConceptMomentSummary(input: $input) {
    summary
    conceptLabel
    captionCount
    startTimecode
    endTimecode
    generatedAt
  }
}
    `

/**
 * __useVideoConceptMomentSummaryQuery__
 *
 * To run a query within a React component, call `useVideoConceptMomentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoConceptMomentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoConceptMomentSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVideoConceptMomentSummaryQuery (baseOptions: Apollo.QueryHookOptions<VideoConceptMomentSummaryQuery, VideoConceptMomentSummaryQueryVariables> & ({ variables: VideoConceptMomentSummaryQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VideoConceptMomentSummaryQuery, VideoConceptMomentSummaryQueryVariables>(VideoConceptMomentSummaryDocument, options)
}
export function useVideoConceptMomentSummaryLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<VideoConceptMomentSummaryQuery, VideoConceptMomentSummaryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VideoConceptMomentSummaryQuery, VideoConceptMomentSummaryQueryVariables>(VideoConceptMomentSummaryDocument, options)
}
export function useVideoConceptMomentSummarySuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoConceptMomentSummaryQuery, VideoConceptMomentSummaryQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<VideoConceptMomentSummaryQuery, VideoConceptMomentSummaryQueryVariables>(VideoConceptMomentSummaryDocument, options)
}
export type VideoConceptMomentSummaryQueryHookResult = ReturnType<typeof useVideoConceptMomentSummaryQuery>;
export type VideoConceptMomentSummaryLazyQueryHookResult = ReturnType<typeof useVideoConceptMomentSummaryLazyQuery>;
export type VideoConceptMomentSummarySuspenseQueryHookResult = ReturnType<typeof useVideoConceptMomentSummarySuspenseQuery>;
export type VideoConceptMomentSummaryQueryResult = Apollo.QueryResult<VideoConceptMomentSummaryQuery, VideoConceptMomentSummaryQueryVariables>;
export const VideoConceptMomentPromptsDocument = gql`
    query VideoConceptMomentPrompts($input: VideoConceptMomentPromptsInput!) {
  videoConceptMomentPrompts(input: $input) {
    prompts {
      prompt
      focus
      rationale
    }
    conceptLabel
    generatedAt
  }
}
    `

/**
 * __useVideoConceptMomentPromptsQuery__
 *
 * To run a query within a React component, call `useVideoConceptMomentPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoConceptMomentPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoConceptMomentPromptsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVideoConceptMomentPromptsQuery (baseOptions: Apollo.QueryHookOptions<VideoConceptMomentPromptsQuery, VideoConceptMomentPromptsQueryVariables> & ({ variables: VideoConceptMomentPromptsQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VideoConceptMomentPromptsQuery, VideoConceptMomentPromptsQueryVariables>(VideoConceptMomentPromptsDocument, options)
}
export function useVideoConceptMomentPromptsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<VideoConceptMomentPromptsQuery, VideoConceptMomentPromptsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VideoConceptMomentPromptsQuery, VideoConceptMomentPromptsQueryVariables>(VideoConceptMomentPromptsDocument, options)
}
export function useVideoConceptMomentPromptsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoConceptMomentPromptsQuery, VideoConceptMomentPromptsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<VideoConceptMomentPromptsQuery, VideoConceptMomentPromptsQueryVariables>(VideoConceptMomentPromptsDocument, options)
}
export type VideoConceptMomentPromptsQueryHookResult = ReturnType<typeof useVideoConceptMomentPromptsQuery>;
export type VideoConceptMomentPromptsLazyQueryHookResult = ReturnType<typeof useVideoConceptMomentPromptsLazyQuery>;
export type VideoConceptMomentPromptsSuspenseQueryHookResult = ReturnType<typeof useVideoConceptMomentPromptsSuspenseQuery>;
export type VideoConceptMomentPromptsQueryResult = Apollo.QueryResult<VideoConceptMomentPromptsQuery, VideoConceptMomentPromptsQueryVariables>;
export const GetChatSessionByVideoDocument = gql`
    query GetChatSessionByVideo($contentId: String!, $featureMediaId: String!) {
  oracleChatSessionList(
    limit: 1
    offset: 0
    useMaster: true
    where: {contentId: {eq: $contentId}, featureMediaId: {eq: $featureMediaId}}
    order: [["updatedAt", "DESC"]]
  ) {
    oracleChatSessions {
      id
      name
      personalityId
      contentId
      featureMediaId
      updatedAt
      createdAt
    }
    limit
    offset
    count
  }
}
    `

/**
 * __useGetChatSessionByVideoQuery__
 *
 * To run a query within a React component, call `useGetChatSessionByVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatSessionByVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatSessionByVideoQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      featureMediaId: // value for 'featureMediaId'
 *   },
 * });
 */
export function useGetChatSessionByVideoQuery (baseOptions: Apollo.QueryHookOptions<GetChatSessionByVideoQuery, GetChatSessionByVideoQueryVariables> & ({ variables: GetChatSessionByVideoQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetChatSessionByVideoQuery, GetChatSessionByVideoQueryVariables>(GetChatSessionByVideoDocument, options)
}
export function useGetChatSessionByVideoLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<GetChatSessionByVideoQuery, GetChatSessionByVideoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetChatSessionByVideoQuery, GetChatSessionByVideoQueryVariables>(GetChatSessionByVideoDocument, options)
}
export function useGetChatSessionByVideoSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatSessionByVideoQuery, GetChatSessionByVideoQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetChatSessionByVideoQuery, GetChatSessionByVideoQueryVariables>(GetChatSessionByVideoDocument, options)
}
export type GetChatSessionByVideoQueryHookResult = ReturnType<typeof useGetChatSessionByVideoQuery>;
export type GetChatSessionByVideoLazyQueryHookResult = ReturnType<typeof useGetChatSessionByVideoLazyQuery>;
export type GetChatSessionByVideoSuspenseQueryHookResult = ReturnType<typeof useGetChatSessionByVideoSuspenseQuery>;
export type GetChatSessionByVideoQueryResult = Apollo.QueryResult<GetChatSessionByVideoQuery, GetChatSessionByVideoQueryVariables>;
